export default __webpack_public_path__ + "static/media/steps-cover-2.479d15f6.png";